import { PickerInput } from '@epam/promo';
import { IEditable, useArrayDataSource } from '@epam/uui-core';
import { USER_ROLE, UserRole } from 'models/user.model';
import { LabeledInputProps } from '@epam/uui/components/layout/LabeledInput';
import css from './PermissionPicker.module.scss';

export const UserRolePicker = ({
  value,
  onValueChange,
  isDisabled,
}: IEditable<UserRole> & LabeledInputProps) => {
  const roles = Object.keys(USER_ROLE)
    .filter((role) => role !== 'GUEST')
    .map((role) => ({
      id: role,
      value: USER_ROLE[role as UserRole],
    }));
  const dataSource = useArrayDataSource({ items: roles }, []);

  return (
    <PickerInput
      disableClear
      dataSource={dataSource}
      dropdownPlacement="bottom-end"
      entityName="name"
      getName={(item) => item.value}
      inputCx={css.permissionPicker__input}
      isDisabled={isDisabled}
      minBodyWidth={200}
      searchPosition="none"
      selectionMode="single"
      size="36"
      value={value}
      valueType="id"
      onValueChange={onValueChange}
    />
  );
};
